<template>
  <!-- 顶部 -->
  <Layou
    class="Mxchm_layou px_1"
    ref="mxchmLayou"
    header
    mian
    left
    right
    mxchmLeft="280px"
    mxchmRight="260px"
  >
    <template v-slot:header>
      <Header />
    </template>
    <template v-slot:right>
      <!-- <el-menu :default-openeds="['', '']" class="right_menu">
        <el-menu-item
          v-for="(item,i) in chmList"
          :key="i"
          :index="''+item.id"
          style=" height: 20px;
    line-height: 20px;"
        >
          <a
            class="right_point"
            style="text-align: left"
            :class="rightmMenuId===item.id? 'right-scroll-active right_point_active':''"
            @click="onRightmMenuClick(item.id)"
            :href="'#help_point_'+item.id"
          >{{item.account}}</a>
        </el-menu-item>

      </el-menu>-->
      <SideCatalog v-bind="catalogProps" :key="initSuccess"></SideCatalog>
    </template>
    <template v-slot:left>
      <div class="left_title">
        <span style="font-weight:bold;font-size:20px">全部文档</span>
        <span
          class="el-icon-menu left_title_icon"
          @mouseenter="isLeftBoxShow = true"
        ></span>
      </div>
      <hr />
      <el-tree
        ref="tree"
        class="chm_tree"
        :data="chmTyleList"
        node-key="id"
        :default-expanded-keys="check"
        :default-checked-keys="check2"
        :props="defaultProps"
        :highlight-current="true"
        :auto-expand-parent="true"
        check-on-click-node
        :current-node-key="currentNodeKey"
        @node-click="put"
        @mouseover="mouseOver"
        @mouseleave="mouseLeave"
      ></el-tree>
    </template>
    <template v-slot:main>
      <div class="chm_fliex_box">
        <div class="overlay" v-show="showOverlay">
            <div class="loadEffect">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
          </div>
        </div>
      
        <div class="chm_mbx">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><a href="/">文档首页</a></el-breadcrumb-item>
            <el-breadcrumb-item v-if="item.item1">{{
              item.item1
            }}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="item.item2">{{
              item.item2
            }}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="item.item3">{{
              item.item3
            }}</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="page-title">
            <p class="page-title-content">
              {{ current.name }}
              <span class="page-title-time"
                >（ 最近更新时间：{{ current.renewTime }} ）</span
              >
            </p>
          </div>
        </div>
      </div>

      <div class="chm_main_content" id="mainContent" ref="mainContent">
        <div @mouseleave="isLeftBoxShow = false" v-show="isLeftBoxShow">
          <el-card class="left_title_menu" shadow="never">
            <template v-for="(item, index) in chmTyleList">
              <div
                class="rong-sidebar-summary"
                v-if="item.next || item.type == 0"
                :key="index"
              >
                <p class="rong-sidebar-summary-title">{{ item.name }}</p>
                <template v-if="!item.next">
                  <div class="rong-sidebar-sub-summary">
                    <ul>
                      <li>
                        <a @click="allChm(item.id)">{{ item.name }}</a>
                      </li>
                    </ul>
                  </div>
                </template>

                <template v-else>
                  <div
                    class="rong-sidebar-sub-summary"
                    v-for="(item2, index2) in item.next"
                    :key="index2"
                  >
                    <template v-if="!item2.next">
                      <ul>
                        <li>
                          <a @click="allChm(item2.id)">{{ item2.name }}</a>
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <p class="rong-sidebar-sub-summary-title">
                        {{ item2.name }}
                      </p>
                      <ul v-if="item2.next">
                        <li v-for="(item3, index3) in item2.next" :key="index3">
                          <a @click="allChm(item3.id)">{{ item3.name }}</a>
                        </li>
                      </ul>
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </el-card>
        </div>

        <!-- <div class="chm_fliex_div"></div> -->

        <!-- 文档内部分类        -->
        <!-- <template>
                <el-radio-group v-model="tabPosition">
                  <el-radio-button label="left">客户端</el-radio-button>
                  <el-radio-button label="right">服务端</el-radio-button>
                </el-radio-group>

              <el-tabs :tab-position="tabPosition" v-model="activeName">
                <el-tab-pane name="first">
                <span slot="label">我的行程1</span>

                </el-tab-pane>
                <el-tab-pane name="first2">
                <span slot="label"> 我的行程2</span>

                </el-tab-pane>

              </el-tabs>
        </template> -->

        <template v-if="type1.length > 1 && type2.length > 0">
          <el-radio-group v-model="tabPosition" @change="chmtabs1">
            <el-radio-button
              v-for="(item, i) in type1"
              :key="i"
              :label="'' + item.id"
              >{{ item.name }}</el-radio-button
            >
          </el-radio-group>

          <el-tabs
            @tab-click="chmtabs2"
            v-model="activeName"
            :v-if="type2.length > 0"
          >
            <el-tab-pane
              v-for="(item, i) in type2"
              :key="i"
              :name="'' + item.id"
            >
              <span slot="label">{{ item.name }}</span>
            </el-tab-pane>
          </el-tabs>
        </template>
        <template v-for="(item, i) in chmList">
          <div class="title_left_div1" :key="'s' + i">
            <a class="title_left_a" :href="'#' + item.account">#</a>
          </div>
          <div class="title_left_div" :key="'a' + i">
            <span
              style="font-size: 22px;color:#000000"
              class="chm_work_title_i"
              :key="i"
              v-html="item.title_h"
            ></span>
          </div>

          <!--          <span style="font-size: 22px;color:#000000;" class="chm_work_title_i" :key="i" v-html="item.title_h"></span>-->
          <div v-html="item.content" :key="'b' + i"></div>
          <div style="width: 100%;height: 25px" :key="'c' + i"></div>
        </template>
        <div class="rong-like">
          <p class="rong-like-title">文档是否解决您的问题 ?</p>
          <div class="rong-like-btn-box">
            <a
              class="rong-like-btn iconfont icon-zan"
              :class="isRongLike === 1 ? 'rong-like-btn-active' : ''"
              @click="isRongLike === 0 ? (isRongLike = 1) : ''"
              disabled="disabled"
              selected="selected"
            ></a>
            <a
              class="rong-dislike-btn iconfont icon-praise"
              :class="isRongLike === 2 ? 'rong-like-btn-active' : ''"
              @click="isRongLike === 0 ? (isRongLike = 2) : ''"
              disabled="disabled"
            ></a>
          </div>

          <div
            class="rong-like-success-box"
            v-if="isRongLike === 1 || isRongLike === 2"
          >
            <i class="rong-like-success-icon el-icon-success"></i>
            <div class="rong-like-success-content">
              <p class="rong-like-success-title">提交成功</p>
              <p class="rong-like-success-thank">
                非常感谢您的反馈，我们会继续努力做到更好 !
              </p>
            </div>
          </div>
          <div class="rong-like-other">
            <p>
              如果遇到产品相关问题，您可
              <template v-if="userinfo.userId == 0">
                <a
                  href="/login"
                  target="_blank"
                  style="color:#09f;text-decoration: none;"
                  >提交工单</a
                >
              </template>
              <template v-else>
                <a
                  href="/mywork"
                  target="_blank"
                  style="color:#09f;text-decoration: none;"
                  >提交工单</a
                >
              </template>
              寻求帮助
            </p>
          </div>

          <el-divider></el-divider>
          <div
            class="page-nav"
            style="transition: all 0.25s ease-in-out 0.32s; transform: translateY(0px); opacity: 1;"
          >
            <p class="inner">
              <span class="prev">
                <!--             <el-image :src="jiantou_left" alt="left" style="width: 30px; height: 30px"></el-image>-->

                <div style="float: left;">
                  <img
                    src="https://admin.mxdraw3d.com/static/image/jiantou_xiangzuo_o.svg"
                    style="width: 30px;height: 20px;line-height: 17px"
                  />
                </div>

                <a @click="allChm(up.id)" class="prev">{{ up.name }}</a></span
              >
              <span class="next"
                ><a @click="allChm(next.id)" class="">{{ next.name }}</a>
                <div style="float: right;">
                  <img
                    src="https://admin.mxdraw3d.com/static/image/jiantou_xiangyou_o.svg"
                    style="width: 30px;height: 20px;line-height: 17px"
                  />
                </div>
              </span>
            </p>
          </div>
        </div>
      </div>
    </template>
    <el-button
      v-show="topShow"
      class="top"
      type="primary"
      icon="el-icon-top"
      @click="scrollToTop"
      circle
    ></el-button>

    <Feedback />
  </Layou>
</template>

<script>
import Layou from "../components/Layou/index.vue";
import Header from "../components/MxChm/Header";
import Feedback from "../components/Feedback.vue";
import SideCatalog from "../assets/vue-side-catalog.js";
import "vue-side-catalog/lib/vue-side-catalog.css";
export default {
  name: "MxChm",
  components: {
    Layou,
    Header,
    SideCatalog,
    Feedback
  },

  data() {
    return {
      tabPosition: "",
      activeName: "",
      type1: [],
      type2: [],
      currentNodeKey: null,
      item: {},
      chmList: [],
      chmTyleList: [],
      userinfo: {},
      pid: 48,
      activeIndex: "1",
      keywords: "",
      initSuccess: 0,
      check: [],
      check2: [],
      logo: require("../assets/img/logo2.png"),
      defaultProps: {
        children: "next",
        label: "name"
      },
      topShow: false,
      catalogProps: {
        container: "#mainContent",
        levelList: ["title_left_div", "chm_work_title_i"],
        innerScroll: true,
        // 偏移量
        theOffset: -141,
        // 动画速度差值
        rollingRate: 10
      },
      listHeight: [],
      restaurants: [],
      state: "",
      timeout: null,
      hrefQuery: "/",
      isRongLike: 0,
      up: {},
      next: {},
      current: {},
      isLeftBoxShow: false,
      showOverlay: false,
      timer: false
    };
  },
  created() {
    //判断是否是从搜索跳转过来的
    let _pid = parseInt(this.$route.query.pid);
    let _keywords = this.$route.query.keywords;
    let pid = !_pid ? this.pid : _pid;
    let keywords = !_keywords ? this.keywords : _keywords;
    this.get(pid, keywords);
    //SyntaxHighlighter.highlight()
    // setTimeout(()=>{
    //     SyntaxHighlighter.highlight()
    // },100)
  },
  mounted: function() {
    // SyntaxHighlighter.config.blogerMode = true;
    // const mainContent = document.querySelector('#mainContent')
    // const imgs = mainContent.querySelectorAll('img')
    // let imgIndex = 0
    // imgs.forEach(img=> {
    //   img.onload = ()=> {
    //     imgIndex ++
    //     if(imgIndex == imgs.length) {
    //       this.Lazyloading(500);
    //     }
    //     img.onload = null
       
    //   }
    // })
    // this.get(this.pid, this.keywords);
       
    // 强制刷新目录
    window.onload = () => {
      // this.Lazyloading(500);
      // console.log(SyntaxHighlighter,'---')
      // hljs.initHighlightingOnLoad();
      // SyntaxHighlighter.highlight(); //调用百度富文本编辑器的代码高亮样式
      
      
    };

    // 滚动条滚动事件
    this.$refs.mainContent.addEventListener("scroll", this.isShowTop);
    const div = document.createElement("div");
    div.style.height = "30px";
    div.style.width = "100%";

    // this.$refs.mxchmLayou.$el.innerHTML+= "<div style='height: 50px;width: 100%;'></div>"
    this.$refs.mxchmLayou.$el.append(div);
  },
  computed: {
    topIsShow() {
      return;
    }
  },
  watch: {
    chmList: function() {
        const that = this
        that.showOverlay = true
        let imgIndex = 0
        window.clearInterval(that.timer)
        that.timer = setInterval(function () {
            if (document.readyState === 'complete') {
                hljs.initHighlightingOnLoad();
                hljs.initLineNumbersOnLoad();
                const mainContent = document.querySelector('#mainContent')
                const imgs = mainContent.querySelectorAll('img')
                if(imgs.length === 0) {
                  that.initSuccess++;
                  that.showOverlay = false
                }
                imgs.forEach(img=> {
                  const timer = setInterval(function() {
                      if (img.complete) {
                      clearInterval(timer)
                      imgIndex ++
                      if(imgIndex == imgs.length) {
                           that.initSuccess++;
                           that.showOverlay = false
                      }
                      
                      }
                  }, 50)
                  // img.onload = (()=> {
                  //   return ()=> {
                  //     imgIndex ++
                  //     console.log(imgIndex)
                  //     if(imgIndex == imgs.length) {
                  //       that.showOverlay = false
                  //     }
                  //   }
                  // })()
                })
                window.clearInterval(that.timer)
            }
        }, 1000)
      // this.$nextTick(function() {
      //     hljs.initHighlightingOnLoad();
      //     hljs.initLineNumbersOnLoad();
      //     this.Lazyloading(500);
      // });
    }
  },
  methods: {
    Lazyloading(time) {
      // 延迟加载
      setTimeout(() => {
        this.$nextTick(() => {
         this.initSuccess++;
        });
      }, Number(time || 0));
    },
    // Top显示
    isShowTop() {
      const mainContent = this.$refs.mainContent;
      mainContent.scrollTop > 800
        ? (this.topShow = true)
        : (this.topShow = false);
    },

    scrollToTop() {
      const mainContent = this.$refs.mainContent;
      function doAnimation(startValue, endValue, duration, el) {
        //使用闭包保存变量dy和step(每次动画滚动的距离)
        let dy = 0;
        let step = (endValue - startValue) / (duration / 10);
        return function(interval) {
          dy += step; //这里改成使用绝对值判断
          if (Math.abs(dy) >= Math.abs(endValue - startValue)) {
            clearInterval(interval);
          }
          el.scrollTop += step;
        };
      }
      let startTop = mainContent.scrollTop; //最终值
      let endTop = 0; //生成一个动画控制函数
      let scrollAnimationFn = doAnimation(startTop, endTop, 300, mainContent); //执行动画，每10ms执行一次
      let interval = setInterval(() => {
        scrollAnimationFn(interval);
      }, 10);
    },
    async get(pid, keywords) {
      var that = this;
      //发送get请求
      const res = await this.$api.get(
        "/help_doc_index?pid=" + pid + "&keywords=" + keywords
      );
      if(!res) {
         that.showOverlay = false
      }
      that.currentNodeKey = pid;
      //that.check.push(pid);
      that.check = [pid];
      that.check2 = [pid];
      that.pid = pid;

      that.chmList = res.data.chmList;
      that.chmTyleList = JSON.parse(res.data.typeList);
      that.up = res.data.up;
      that.next = res.data.next;
      that.current = res.data.current;
      // console.log(that.chmTyleList)
      that.item = res.data.item;
      if (res.data.type1.length > 0) {
        that.tabPosition = res.data.type1[0].id.toString();
      }
      if (res.data.type2.length > 0) {
        that.activeName = res.data.type2[0].id.toString();
      }
      that.type1 = res.data.type1;
      that.type2 = res.data.type2;
      that.userinfo = res.data.userInfo;
      // that.Lazyloading(500);

      that.$nextTick(function() {
        that.$refs.tree.setCurrentKey(that.currentNodeKey);
        const content = document.getElementsByClassName("chm_main_content")[0];
        const as = content.getElementsByClassName("help_chm_a");
        for (let i = 0; i < as.length; i++) {
          as[
            i
          ].innerHTML += `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" x="0px" y="0px" viewBox="0 0 100 100" width="15" height="15" class="icon outbound"><path fill="currentColor" d="M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"></path>
<polygon fill="currentColor" points="45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"></polygon>
</svg>`;
          //console.log(as[i].innerHTML)
        }

        // console.log(document.querySelectorAll("pre"));
      });

     
    },

    handleSelect(item) {
      console.log(item);
    },
    async querySearchAsync(queryString, cb) {
      const { data } = await this.$api("/search?k=" + queryString);
      //console.log(data.page.list)
      this.restaurants = data.page.list;
      // cb(data.page.list);
      // var restaurants = this.restaurants;
      // var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      // console.log(data.page.list,results)
      // clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        // cb(results);
        cb(data.page.list);
        // cb( [{ "title": "南拳妈妈龙虾盖浇饭", "address": "普陀区金沙江路1699号鑫乐惠美食广场A13" }])
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleIconClick() {},

    put(data) {
      //执行点击菜单方法，如果没有下级则加载数据
      //!data.next && data.pid!=0
      if (data.type == 0 && !data.next && data.id != this.pid) {
        this.$router.push({
          name: "MxChm",
          query: { pid: data.id }
        });
        this.$nextTick(() => {
          document.getElementById("mainContent").scrollTop = 0;
        });
        this.showOverlay = true
        this.get(data.id, this.keywords);
      }
    },
    allChm(pid) {
      //console.log(pid);
      this.$router.push({
        name: "MxChm",
        query: { pid: pid}
      });
      this.$nextTick(() => {
        document.getElementById("mainContent").scrollTop = 0;
      });
      this.get(pid, this.keywords);
    },
    onChmContentScroll(e) {
      // console.log(e);
      // this.rightmMenuId
    },

    onRightmMenuClick(id) {
      this.rightmMenuId = id;
    },

    chmtabs1(id) {
      var that = this;
      that.tabPosition = id;
      var pid = that.pid;
      // alert(id)
      that.$api.post("/chm_tabs_type", { pid: pid, type: id }).then(
        function(res) {
          if (res.data.code == "success") {
            console.log(res.data);
            that.type2 = res.data.tabs;
            that.chmList = res.data.chm;
            if (res.data.tabs.length > 0) {
              that.activeName = res.data.tabs[0].id.toString();
            }
            // that.Lazyloading(500);
          }
        },
        function() {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
      //console.log(this.activeName,id,this.pid)
      //this.selTabsChm();
    },
    chmtabs2(tab, event) {
      // console.log(tab, event);
      this.activeName = tab.name;
      this.selTabsChm();
      //console.log(tab.name,this.tabPosition,this.pid)
    },
    selTabsChm() {
      var that = this;
      var pid = that.pid;
      var type = that.tabPosition;
      var type2 = that.activeName;
      // console.log(pid,type,type2);return
      that.$api
        .post("/chm_tabs_list", { pid: pid, type: type, type2: type2 })
        .then(
          function(res) {
            console.log(res);
            if (res.data.code == "success") {
              that.chmList = res.data.data;
              // that.Lazyloading(500);
            }
          },
          function() {
            that.$message.error("服务器异常，请稍后重试！");
          }
        );
    },
    mouseOver: function(e) {
      //console.log("鼠标移入");
      //this.activeCss='hover_border'
    },
    mouseLeave: function(e) {
      console.log("鼠标移出");

      //this.activeCss='hover_border'
    }
  }
};
</script>

<style scoped>
.title_left_a {
  display: none;
}
.title_left_div1 {
  width: 500px;
  height: 25px;
  position: relative;
  top: 30px;
  left: -15px;
  z-index: 9999;
}
.title_left_div1:hover .title_left_a {
  display: inline-block;
  /* margin-left: -15px; */
}
/* 滚动条美化 */
.chm_tree::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.chm_tree::-webkit-scrollbar::-webkit-scrollbar-track {
  width: 9px;
  background-color: #0d1b20;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
.chm_tree::-webkit-scrollbar-thumb {
  background-color: rgb(193, 193, 193);
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
.chm_tree::-webkit-scrollbar-thumb:hover {
  background-color: rgb(168, 168, 168);
}

.chm_tree {
  overflow-y: scroll;
  height: calc(100% - 80px);
}
/*.chm_tree::-webkit-scrollbar {*/
/*  width: 0 !important;*/
/*  -ms-overflow-style: none;*/
/*  overflow: -moz-scrollbars-none;*/
/*}*/
.chm {
  max-width: 1500px;
  margin: 0 auto;
  height: 100%;
}

.chm_menu {
  height: 60px;
  width: 100%;
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  z-index: 10000;
}

/* 主体内容div */
.chm_main {
  margin-top: 60px;
}

/* logo包裹容器 */
.chm_logo {
  font-weight: 100;
  font-size: 1rem;
  background-color: #ffffff;
  height: 60px;
  margin: 0;
  display: flex;
  cursor: pointer;
  align-items: center;
  /* justify-content: center; */
  float: left;
  margin-right: 20%;
}

/* logo图片样式 */
.chm_logo_img {
  width: 45px;
  display: flex;
  align-items: center;
}

/* 左侧边栏 */
.chm_main_left {
  width: 200px;
  position: fixed;
  background-color: #f7f8fa;
  height: 100%;
  z-index: 9999;
  overflow: visible;
}
.chm_main_left:before {
  position: absolute;
  content: "";
  width: 3000px;
  background-color: #f7f8fa;
  height: 100%;
  right: 100%;
}

/* 右侧边栏 */
.chm_main_right {
  width: 200px;
  margin-left: 995px;
}

/* 文档内容 */
.chm_main_main {
  padding-left: 200px;
  position: relative;
  width: 100%;
  height: 100%;
  /* margin: 0 30%; */
}

.chm_mbx {
  z-index: 1000;
  width: calc(100%);
  background-color: #ffffff;
}

.chm_fixed_box {
  height: 130px;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
}
.el-main {
  padding: 0 !important;
}

.chm_list .chm_title {
  text-indent: 1em;
  margin-top: -80px;
  padding-top: 80px;
}

blockquote {
  font-size: 14px !important;
  color: #333 !important;
  border-left: 0.5rem solid #67b9cc !important;
  margin: 0.5rem 0 !important;
  padding: 0.7rem 1.5rem !important;
  margin: 1rem 0 !important;
  background-color: rgb(243, 244, 244);
}

blockquote {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 40px;
  margin-inline-end: 40px;
}
</style>

<style>
@import url("../assets/css/mxchm.css");
@import url("../assets/css/shCoreDefault.css");
@import url("../assets/css/helpDocument.css");
.left_title {
  text-align: left;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
}
.left_title_icon {
  margin-right: 1rem;
}
.left_title_menu {
  position: fixed;
  display: block;
  max-width: 760px;
  max-height: 500px;
  top: 61px;
  z-index: 1000000;
  margin-left: -40px;
  /*max-height: calc(100% - 100px);*/
  overflow: auto;
  cursor:pointer;
}
/* 视频 */
.video video {
  width: 100%;
  position: absolute;
  height: 100%;
  top: 0;
}
.video {
  position: relative;
  width: 100%;
  height: 0;
  top: 0;

  background-color: #333;
}
.video-16-9 {
  padding-bottom: 56%;
}
.video-4-3 {
  padding-bottom: 56%;
}
.chm_main_content {
  overflow-x: hidden;
  padding: 0 2%;
  height: calc(100%);
  text-align: left;
  overflow-y: scroll !important;
  /* scroll-behavior: smooth; */
}

.chm_main_content::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.chm_main_content::-webkit-scrollbar::-webkit-scrollbar-track {
  width: 9px;
  background-color: #0d1b20;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
.chm_main_content::-webkit-scrollbar-thumb {
  background-color: rgb(193, 193, 193);
  background-clip: padding-box;
  /*min-height: 300px;*/
  /* height: 80%; */
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
  margin-left: 20px;
}
.chm_main_content::-webkit-scrollbar-thumb:hover {
  background-color: rgb(168, 168, 168);
}

.el-tree-node .el-tree-node__content {
  height: 40px;
}
.side-catalog__list-item-title--level1 {
  font-weight: normal !important;
}
.side-catalog__list-item-title {
  text-align: initial;
  font-size: 14px !important;
  font-family: Ubuntu, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Oxygen, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
}
.side-catalog__list {
  padding-left: 6px;
  overflow-y: scroll !important;
}

.side-catalog__list::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.side-catalog__list::-webkit-scrollbar::-webkit-scrollbar-track {
  width: 9px;
  background-color: #0d1b20;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
.side-catalog__list::-webkit-scrollbar-thumb {
  background-color: rgb(193, 193, 193);
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
.side-catalog__list::-webkit-scrollbar-thumb:hover {
  background-color: rgb(168, 168, 168);
}

.el-tree {
  background: unset;
  height: 100%;
}
.el-image {
  display: flex;
}
.Mxchm_layou.layou .header {
  padding: 0 11%;
}
/*----------------*/
.Mxchm_layou.layou .content {
  padding: 0 0% 0 10%;
}

.left {
  background-color: #f7f8fa;
}
.left:before {
  position: absolute;
  content: "";
  width: 3000px;
  background-color: #f7f8fa;
  height: 100%;
  right: 90%;
}
/*----------------*/

.Mxchm_layou.layou .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.Mxchm_layou.layou .el-input-group__append,
.el-input-group__prepend {
  padding: 0 3px;
}
.Mxchm_layou.layou .tree_isshow {
  position: relative;
}
.Mxchm_layou #mainContent {
  padding-top: 141px;
}
.Mxchm_layou #mainContent video {
  max-width: 100%;
  height: auto;
}
.Mxchm_layou #mainContent img {
  height: auto;
  max-width: 100%;
}
/* .Mxchm_layou p {
  line-height: 1 !important;
} */

.xl_show {
  display: none;
}

.rong-sidebar-summary {
  display: inline-block;
  margin-right: 65px;
  vertical-align: top;
  margin-top: 20px;
  width: 160px;
  overflow: hidden;
}

.el-tree-node__label {
  color: #333;
  font-weight: 700;
}

.el-tree-node__children .el-tree-node__label {
  font-weight: normal;
}

.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #ecf3ff;
}

.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content
  .el-tree-node__label {
  color: #09f;
}

/* .el-tree-node__children .is-checked .el-tree-node__label{
        color: #09f;
      background-color: #ecf3ff;
  } */

.rong-sidebar-summary .rong-sidebar-summary-title {
  min-width: 160px;
  font-size: 16px;
  color: #000;
  padding-bottom: 6px;
  border-bottom: 1px solid #d8d8d8;
  margin-top: 0;
}
.rong-sidebar-all .rong-sidebar-all-title {
  font-size: 16px;
  color: #333;
  margin: 0;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 20px;
  z-index: 20;
}
.rong-sidebar-summary .rong-sidebar-sub-summary-title {
  margin-top: 15px;
  margin-bottom: 0;
  font-size: 15px;
  color: #333;
}
.rong-sidebar-summary .rong-sidebar-sub-summary ul {
  margin: 0;
  padding-left: 0;
  line-height: 1.7;
}
.rong-sidebar-summary .rong-sidebar-sub-summary ul li {
  list-style: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 160px;
  height: 26px;
  margin: 0;
  line-height: 1.7;
}
.rong-sidebar-summary .rong-sidebar-sub-summary ul li a {
  color: #09f;
  font-size: 14px;
  text-decoration: unset;
}

.right_menu {
  height: 100%;
  border-left: 1px solid #ccc;
  margin-left: 10px;
}
.right_point {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #000;
  display: block;
}
.right_point_active {
  color: rgb(38, 110, 218);
}
.side-catalog__list-item--active:after {
  content: "";
  position: absolute;
  left: 0;
  width: 8px;
  height: 8px;
  z-index: 99;
  background-color: #09f;
  border-radius: 50%;
  left: 1px;
  margin-left: -6px;
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
}
.side-catalog__list-item-icon {
  display: none;
}
.side-catalog__list-line {
  display: none;
}
.side-catalog {
  height: 100%;
}

.side-catalog__list > div {
  border-left: 1px solid #ccc;
  height: 100%;
}

.top {
  position: absolute;
  bottom: 8%;
  right: 8%;
}
.rong-like {
  padding: 0px 0px 50px 0px;
}
.rong-like .rong-like-title {
  display: inline-block;
  color: #333;
  font-size: 16px;
  margin: 12px 0;
}
.rong-like .rong-like-btn-box {
  display: inline-block;
  margin-left: 40px;
  vertical-align: middle;
}
.rong-like .rong-like-success-box {
  position: relative;
  height: 100px;
  width: 90%;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
}
.rong-like .rong-like-other {
  font-size: 16px;
  color: #333;
}
.rong-like .rong-like-btn-box {
  display: inline-block;
  margin-left: 40px;
  vertical-align: middle;
}
.rong-like .rong-like-btn-box a {
  display: inline-block;
  width: 44px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  box-sizing: border-box;
  background-color: #f1f1f1;
  border: 1px solid #ddd;
}
.rong-like .rong-like-success-box .rong-like-success-icon {
  display: inline-block;
  position: absolute;
  color: #02a854;
  font-size: 20px;
  width: 24px;
  height: 24px;
  top: 50%;
  transform: translateY(-50%);
  left: 30px;
}
.rong-like .rong-like-success-box .rong-like-success-content {
  position: absolute;
  top: 47%;
  transform: translateY(-50%);
  left: 100px;
}
.rong-like .rong-like-success-box .rong-like-success-title {
  color: #333;
  font-size: 16px;
  margin: 7px 0;
}
.rong-like .rong-like-success-box .rong-like-success-thank {
  font-size: 14px;
  color: #666;
  margin: 7px 0;
}
.rong-like-btn-active {
  color: #ccc;
}
.page-nav {
  padding-bottom: 0;
  padding: 0 2.5rem 1rem;
}
.page-nav .inner {
  min-height: 1rem;
  margin-top: 0;
  overflow: auto;
}
.page-nav .next {
  float: right;
}
.page-nav a {
  font-weight: 500;
  color: #09f;
  text-decoration: none;
  cursor: pointer;
}

.page-title {
  padding: 0;
  color: var(--text-color);
}
.page-title-content {
  font-size: 30px;
  margin: 20px 0 0;
  text-align: left;
  padding: 0 2%;
}

.page-title .page-title-time {
  margin: 2px 0 16px;
  font-size: 14px;
  color: #333;
}

.Mxchm_layou .main {
  position: relative;
}
.chm_fliex_box {
  position: absolute;
  width: calc(100% - 10px);
  height: 131px;
  background: #fff;
  z-index: 1000;
}
.chm_fliex_div {
  width: 100%;
  height: 131px;
}
/* 遮罩层 */
.overlay {
  position: fixed;
  width: 251px;
  height: 100%;
  top: 60px;
  right: 0;
  bottom: 0;
  background-color: rgba(244, 244, 244, 0.1);
}
/* lodding */
.loadEffect{
    width: 100px;
    height: 100px;
    position: absolute;   
    top: 0;
    right: 0;
    z-index: 100;
    margin-right: -20px;
    margin-top: -20px;
    transform: scale(0.3);
}
.loadEffect span{
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #1e3034c2;
    position: absolute;
    -webkit-animation: load 1.04s ease infinite;
}
@-webkit-keyframes load{
    0%{
        -webkit-transform: scale(1.2);
        opacity: 1;
    }
    100%{
        -webkit-transform: scale(.3);
        opacity: 0.5;
    }
}
.loadEffect span:nth-child(1){
    left: 0;
    top: 50%;
    margin-top:-10px;
    -webkit-animation-delay:0.13s;
}
.loadEffect span:nth-child(2){
    left: 14px;
    top: 14px;
    -webkit-animation-delay:0.26s;
}
.loadEffect span:nth-child(3){
    left: 50%;
    top: 0;
    margin-left: -10px;
    -webkit-animation-delay:0.39s;
}
.loadEffect span:nth-child(4){
    top: 14px;
    right:14px;
    -webkit-animation-delay:0.52s;
}
.loadEffect span:nth-child(5){
    right: 0;
    top: 50%;
    margin-top:-10px;
    -webkit-animation-delay:0.65s;
}
.loadEffect span:nth-child(6){
    right: 14px;
    bottom:14px;
    -webkit-animation-delay:0.78s;
}
.loadEffect span:nth-child(7){
    bottom: 0;
    left: 50%;
    margin-left: -10px;
    -webkit-animation-delay:0.91s;
}
.loadEffect span:nth-child(8){
    bottom: 14px;
    left: 14px;
    -webkit-animation-delay:1.04s;
}

@media screen and (min-width: 1903px) {
  .Mxchm_layou.layou .content {
    padding: 0 0 0 5%;
  }
  .left:before {
    right: 95%;
  }
}

@media screen and (max-width: 1903px) {
  .Mxchm_layou.layou .content {
    padding: 0 0 0 5%;
  }

  .Mxchm_layou.layou .header {
    padding: 0 5%;
  }
  .left:before {
    right: 95%;
  }
}
@media screen and (max-width: 1433px) {
  .Mxchm_layou.layou .content {
    padding: 0 0% 0 5%;
  }
  .Mxchm_layou.layou .header {
    padding: 0 5%;
  }

  .left:before {
    right: 95%;
  }
}

@media screen and (max-width: 991px) {
  .Mxchm_layou.layou .content {
    padding: 0;
  }
  .Mxchm_layou.layou .header {
    padding: 0;
  }

  .left:before {
    right: 100%;
  }
  .xl_show {
    display: block;
  }
  .el-breadcrumb__inner {
    float: left;
    /* max-width: 125px; */
    max-width: 130px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .el-breadcrumb__item[aria-current] {
    display: none;
  }
  .chm_fliex_box {
    height: 153px;
  }
  .chm_fliex_div {
    height: 153px;
  }
  .page-title {
    line-height: 1;
  }
  .page-nav {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MxChm.vue